<div class="wrap" [class.disabled]="loader.isLoading$ | async">
  <app-modal-generic-header
    [header]="'@components.productSearch.header' | translate"
    (closeClicked)="modalService.dismiss(null)"
  ></app-modal-generic-header>
  <div class="content">
    <app-input
      class="name-input"
      [isMarkedAsRequired]="false"
      [control]="searchControl"
      [placeholder]="'@components.productSearch.input.placeholder' | translate"
    ></app-input>
    <div *ngIf="(foundProducts$ | async) !== null" class="product-list">
      <div
        *ngIf="(foundProducts$ | async)?.length! === 0"
        class="empty-message"
      >
        {{ "@components.productSearch.productList.emptyMessage" | translate }}
      </div>
      <div
        class="product-item"
        *ngFor="
          let product of foundProducts$ | async;
          trackBy: foundProductsTrackByFn
        "
      >
        <app-product-search-list-item
          [product]="product"
          [cartQuantity]="(product | getInStoreCartItemQuantity | async) || 0"
          (productAdded)="addProductToCart($event)"
          (productAmountIncreased)="increaseProductAmount($event)"
          (productAmountDecreased)="decreaseProductAmount($event)"
        ></app-product-search-list-item>
        <hr />
      </div>
    </div>
  </div>
</div>
<div class="app-spinner-container" *ngIf="loader.isLoading$ | async">
  <ion-spinner class="app-spinner"></ion-spinner>
</div>
